import React from "react";
import Contact from "../components/Contact/Contact";
import Navbar from "../components/Home/Navbar";

export default function ContactPage() {
  return (
    <>
      <Navbar />
      <Contact />
    </>
  );
}
